<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-lg navbar-expand-lg-sl navbar-dark bg-dark" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                
            </navbar-toggle-button>
            <a class="navbar-brand d-none d-lg-block navbar-sl-logo" href="/">
                <img :src="logo" class="navbar-brand-img" alt="...">
            </a>            
            <!-- <router-link class="navbar-brand d-none d-lg-block navbar-sl-logo" to="/">
                <img :src="logo" class="navbar-brand-img" alt="...">
            </router-link> -->
            <div class="d-none d-lg-block nav-bar-sl-separation"></div>
            <slot name="mobile-right">
                <ul class="nav align-items-center d-lg-none">
                    <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
                        <a slot="title-container" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-sm rounded-circle">
                                <i class="ni ni-single-02 text-white"></i>
                              </span>
                            </div>
                        </a>
                        <b-link to="/login" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>{{ $t('admin.logout') }}</span>
                        </b-link>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>
            
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-lg-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="/img/brand/logo_astek_black.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
            </div>
            </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'

  export default {
    name: 'sidebarsl',
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/logo_astek_white_and_green.png'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
